import api from '@/services/api';

export default {
  namespaced: true,
  actions: {
    async getProjectSketches(store, projectId) {
      const r = await api.get(`v2/projects-drawings/${projectId}`);
      return r.data.data;
    },
    async createProjectSketch({ dispatch }, { projectId, body }) {
      await api.post(`v2/projects-drawings/${projectId}`, body);
      return await dispatch('getProjectSketches', projectId);
    },
    async removeProjectSketch({ dispatch }, { projectId, sketches }) {
      await api.delete(`v2/projects-drawings/${projectId}`, { data: sketches });
      return await dispatch('getProjectSketches', projectId);
    },
  },
};
